import Summary from './summary/summary';
import Devices from './devices/devices';
import Files from './files/files';
import Goals from './goals/goals';
import Location from './location/location';
import Measurements from './measurements/measurements';
import Parameters from './parameters/parameters';
import Rules from './rules/rules';
import Stories from './stories/stories';
import Edit from './edit/edit';
import Cellular from './cellular/cellular';
import Subregions from './subregions/subregions';
import Boundaries from './radar/boundaries';
import Radar from './radar/radar';
import Firmware from './firmware/firmware';

export default angular
  .module('main.devices.edit.tabs', [
    Summary,
    Devices,
    Files,
    Goals,
    Location,
    Measurements,
    Parameters,
    Rules,
    Stories,
    Edit,
    Cellular,
    Subregions,
    Boundaries,
    Radar,
    Firmware,
  ])
  .name;
